import { SceneAssetRelation } from './scene-asset-relations/SceneAssetRelation';
import { BaseAsset } from './assets/BaseAsset';
import { AssetEvent } from './vr-events/AssetEvent';
import { AssetInBaseAsset } from './assets-in-base-asset/AssetInBaseAsset';
import { QuestionRule } from './question-rules/QuestionRule';
import { OutcomeAction } from './outcomes/OutcomeAction';

export class AssetInScene{
    name: string;
    sceneAssetRelation: SceneAssetRelation;
    baseAsset: BaseAsset;
    events: AssetEvent[];
    questionRules: QuestionRule[];
    outcomeActions: OutcomeAction[];
    assets: AssetInScene[];
    expanded: boolean;
    toBeRemoved: boolean;
    removed: boolean;
}